export default __webpack_public_path__ + "static/media/FamilyNumber6.bfc82367.svg";